module.exports = __webpack_public_path__ + "static/media/story_16.c048e43f.jpg";